import React from "react";
import './styles/BackgroundVideo.css'
import { Link } from "react-router-dom";


const BackgroundVideo = () => {
  return (
    <div className="video-container" style={{ marginTop: "0", padding: "100px 20px" }}>
      {/* Background Video */}
      <video className="video-background" autoPlay muted loop>
        <source src="/assets/videos/intro.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Content Overlay */}
      <div className="content">
        <h1>Alex Turner Estates</h1>
        <strong>Luxury Homes, Waterfront Properties, Eco-Friendly Homes</strong>
        <div className="btn-wrap">
        <Link to="/exclusiveListings"  className="lp-btn">Search All Homes</Link>
        </div>
      </div>
    </div>
  );
};

export default BackgroundVideo;
